import LoadingLayer from "../components/LoadingLayer";


const LoadingPage = () => {
  return (
    <>
      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        {/* <Breadcrumb title="404" /> */}

        {/* ErrorLayer */}
        <LoadingLayer />


      {/* </MasterLayout> */}
    </>
  );
};

export default LoadingPage;
